
<template>
    <div class="ratings">
        <rating v-for="rating in ratings" :key="rating.id" :student="student" :rating="rating"/>

        <template v-if="ratings.length > $options.limit">
            <br>

            <b-pagination
                    :total="student.ratings.length"
                    :current.sync="page"
                    :per-page="$options.limit"
                    order="is-centered"/>
        </template>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
    import Rating from '@/taskflex/students/components/profile/ratings/Rating';

    export default {
        data() {
            return {
                page: 1,
            };
        },

        props: {
            student: {
                type: Object,
                required: true,
            },
        },

        limit: 3,

        computed: {
            ratings() {
                const {
                    $options: {
                        limit,
                    },

                    student: {
                        ratings,
                    },

                    page,
                } = this;

                const realPage = page - 1;

                return ratings.slice(realPage * limit, (realPage + 1) * limit);
            },
        },

        components: {
            Rating,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/students/components/profile/ratings/RatingsList.vue